<template>
    <div><!-- 出貨單列印明細 -->
        <CCard>
            <CCardBody>
                <div class="d-flex justify-content-end">
                    <div>
                        <button class="btn btn-edit mb-2 mr-2" @click="deliveryPrintEvent">{{$t('Buttons.Print')}}</button>
                        <router-link class="btn btn-secondary mb-2" @click.native="goBackEvent" to="">{{$t('Buttons.GoBack')}}</router-link>
                    </div>
                </div>
                <div class="info">
                    <div class="info_col">
                        <p>{{i18n('ShipmentPrinting.Factory')}}: {{deliveryRow.werks}}</p>
                        <p>{{i18n('ShipmentPrinting.FactoryName')}}: {{deliveryRow.bukrsTxtZf}}</p>
                        <p>{{i18n('ShipmentPrinting.DocumentDate')}}: {{deliveryRow.Txt}}</p>
                        <p>{{i18n('ShipmentPrinting.VendorCode')}}: {{deliveryRow.lifnr}}</p>
                        <p>{{i18n('ShipmentPrinting.GoodsSupplierCode')}}: {{deliveryRow.gsLifnr}}</p>
                        <p>{{i18n('ShipmentPrinting.Currency')}}: {{deliveryRow.waers}}</p>
                        <p>{{i18n('ShipmentPrinting.Incoterms')}}: {{deliveryRow.inco1}}  {{deliveryRow.inco2}}</p>
                        <p>{{i18n('ShipmentPrinting.BillAddress')}}: {{deliveryRow.billTo}}</p>
                        <p>{{i18n('ShipmentPrinting.DeliveryAddress')}}: {{deliveryRow.shipTo}}</p>                        
                        <p v-for="(it, index) in getRemarkList()" :key="'remark_'+index">{{getRemarkItemTxt(it,index)}}</p>
                    </div>
                    <div class="info_col">
                        <p>&nbsp;</p>
                        <p>{{i18n('ShipmentPrinting.PurchasingDocument')}}: {{deliveryRow.bsart + '-' + deliveryRow.ebeln}}</p>
                        <p>{{i18n('ShipmentPrinting.PurchaseGroup')}}: {{deliveryRow.ekgrpTxt}}</p>
                        <p>{{i18n('ShipmentPrinting.Vendor')}}: {{deliveryRow.customerName}}</p>
                        <p>{{i18n('ShipmentPrinting.GoodsSupplier')}}: {{deliveryRow.gsLifnrName1}}</p>
                        <p>{{i18n('ShipmentPrinting.TermsOfPaymnt')}}: {{deliveryRow.ztermTxt}}</p>
                        <p>{{i18n('ShipmentPrinting.ShippingMethod')}}: {{deliveryRow.expvzTxt}}</p>
                    </div>
                </div>                
                <table class="table ">
                    <thead class="thead-light">
                        <tr>
                            <th class="text-center">{{headers[0]}}</th>
                            <th class="text-center">{{headers[1]}}</th>
                            <th class="text-center">{{headers[2]}}</th>
                            <th class="text-center">{{headers[3]}}</th>
                            <th class="text-center">{{headers[4]}}</th>
                            <th class="text-center">{{headers[5]}}</th>
                            <th class="text-center">{{headers[6]}}</th>
                            <th class="text-center">{{headers[7]}}</th>
                            <th class="text-center">{{headers[8]}}</th>
                        </tr>
                    </thead>
                    <tbody>                        
                        <tr class="dashed" v-for="(item , index) in deliverySelected.rows" :key="item.proid + index">                        
                            <td class="text-left">
                                {{item.ebelp}}
                            </td>
                            <td class="text-left">{{item.ebeln + '-' + item.ebelp}}</td>
                            <td class="text-left">{{item.matnr}}</td>
                            <td class="text-left">{{item.revlv}}</td>
                            <td class="text-left">{{item.txz01}}</td>
                            <td class="text-left">{{item.groes}}</td>
                            <td class="text-right">
                                <input type="number" v-model="item.shipments"
                                    @change="checkMaxValue(item)" >
                            </td>
                            <td class="text-right">{{item.netpr | currencyF5}}</td>
                            <td class="text-right">{{calcNetwr(item) | currencyF2}}</td>
                        </tr>
                    </tbody>
                </table>
            </CCardBody>
        </CCard>
    </div>
</template>
<script>
import { orderMixin } from '@/mixin/order'
import { mapGetters } from 'vuex'
export default {
    mixins: [orderMixin],
    data() {
        return {
            headers : [
                this.i18n('ShipmentPrinting.Check'),this.i18n('ShipmentPrinting.PurchasingDocumentItem'),this.i18n('ShipmentPrinting.Material'),this.i18n('ShipmentPrinting.MaterialVersion'),this.i18n('ShipmentPrinting.ShortText'),this.i18n('ShipmentPrinting.Specification')
                ,this.i18n('ShipmentPrinting.ShipmentsQuantity'),this.i18n('ShipmentPrinting.NetPrice'),this.i18n('ShipmentPrinting.NetAmount')
            ],  
            deliveryRow : {},
            deliverySelected: {
                rows: []
            }            
        }
    },
    props : {
    },
    watch: {
        'lang': function() {
            this.headers = [
                this.i18n('ShipmentPrinting.Check'),this.i18n('ShipmentPrinting.PurchasingDocumentItem'),this.i18n('ShipmentPrinting.Material'),this.i18n('ShipmentPrinting.MaterialVersion'),this.i18n('ShipmentPrinting.ShortText'),this.i18n('ShipmentPrinting.Specification')
                ,this.i18n('ShipmentPrinting.ShipmentsQuantity'),this.i18n('ShipmentPrinting.NetPrice'),this.i18n('ShipmentPrinting.NetAmount')
            ]
        }
    },
    methods: {        
        deliveryPrintEvent (){ //列印
            const queryParam = {};
            this.getCacheQueryParam('Delivery_QueryParam' , queryParam);
            const url = `${this.$apiUrl_Print}/PrepareDeliveryPrintAsync`;
            queryParam.listShipments = this.deliverySelected.rows;            
            this.axios.post(url, queryParam).then((response) => {                        
                const token = response.data;                                 
                let urlPrint = `${this.$apiUrl_Print}/PrintDeliveryReport/${token}`;
                this.openNewTabByALink('printDeliveryReport',urlPrint);
            })
        },
        goBackEvent (){
            this.$router.push('delivery');
        },
        getRemarkList (){
            const rt = this.reBuildRemarkList(this.deliveryRow);            
            return rt;
        },
        checkMaxValue(item) {            
            if(item) {
                if(item.shipments > item.maxShipments){
                    this.$alert('已超過應交貨數量！','警告',{type: 'warning'});
                    item.shipments = item.maxShipments
                }else if(item.shipments < 0){
                    this.$alert('不能輸入負數！','警告',{type: 'warning'});
                    item.shipments = 0;
                }
            } 
        },
        calcNetwr(item){            
            if(item && item.shipments <= item.maxShipments){
                const calcVal = item.shipments * item.netpr;                
                return calcVal;//Number.parseFloat(item.netwr).toFixed(3);
            }
            return item.netwr;
        },
        i18n (keyStr){
            return this.$t(keyStr);
        },
    },
    computed: {
        ...mapGetters(['lang'])
    },
	mounted() {        
        this.getCacheQueryParam('Delivery_SelectedRows' , this.deliverySelected);        
        if(this.deliverySelected && this.deliverySelected.rows && this.deliverySelected.rows.length >0){
            this.deliveryRow = this.deliverySelected.rows[0];
        }
	},
    created() {        
    }
}
</script>
<style lang="scss" scoped>
table th:first-child {
    text-align: center;
    padding: 15px 5px;
}

.table tr:nth-child(even) {
    background-color: transparent;
}

.info {
    display: flex;
    flex-direction: row;
    border: 1px solid #ececec;
    padding-top: 1rem;
}
.info_col {
    display: flex;
    flex-direction: column;

    > p {
        margin-left: 1rem;
        margin-right: 1rem;
    }
}
.dashed {
    // border-bottom: none;
    // border-bottom: 2px dashed;
}
.reply {
    // display: flex;
    // flex-direction: column;
    // border: none;
    
    .btn {
        margin-top: 4rem;
    }
}

.money {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-top: 6rem;
    margin-right: 8rem;
    .money-col {
        display: flex;
    }
}
.btn-secondary {
    color: #fff;
    background-color: #262626;
}
.table td input {
    border: 1px solid black;
}
.btn-edit {
    background-color: #343b55;
    color: white;
}
</style>
